 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Currency
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryCurrFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryCurrFilterForm"
                            v-model="filtersCurrency.currency"
                            :label="filtersCurrencyLabel.currency"
                            :error-messages="errors.collect('filterCurrency')"
                            data-vv-name="filterCurrency"
                            :data-vv-as="filtersCurrencyLabel.currency"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearCurrFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doCurrFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="currencyHeaders"
          :items="currencyItems"
          v-bind:options.sync="paginationCurrency"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsCurrency"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.curr }}</td>
              <td>{{ row.item.currDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignCurr(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationCurrency: {
        page: 1
      }
    }
  },
  mounted() {
  },
  watch: {
    boolRefresh: function(value) {
      if (value) {
        this.doClearCurrFilters()
      }
    },
    'paginationCurrency': function(value) {
      this.doClearCurrFilters()
    }
  },
  methods: {
    closeDialog() {
      this.filtersCurrency.currency = ''
      this.$emit('close')
    },
    doClearCurrFilters() {
      this.filtersCurrency.currency = null
      this.fetchCurrecyData()
    },
    doCurrFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryCurrFilterForm').then((result) => {
        if (result) {
          this.paginationCurrency.page = 1
          this.fetchCurrecyData()
        }
      })
    },
    assignCurr(data) {
      this.$emit('assign-currency', data.curr)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin]
}
</script>
